import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { ErrorsHandler } from './errors.handler';
import { ServerErrorsInterceptor } from './_interceptors/server-errors.interceptor';
import { JwtInterceptor } from './_interceptors/jwt.interceptor';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

// Services
import { NotificationService } from './_services/notification.service';
import { AuthService } from './_services/auth.service';
import { CryptoService } from './_services/crypto.service';
import { GroupUserService } from './_services/group-user.service';
import { OwnerUserService } from './_services/owner-user.service';
import { StoreService } from './_services/store.service';
import { StoreContextService } from './_services/store-context.service';
import { CategoryService } from './_services/category.service';
import { FoodToGoService } from './_services/food-to-go.service';
import { KioskCategoryService } from './_services/kiosk-category.service';
import { AppsService } from './_services/apps.service';
import { ProductsService } from './_services/products.service';
import { ConsoleUserService } from './_services/console-user.service';
import { CustomBuilderService } from './_services/custom-bulider.service';
import { OrderGroupService } from './_services/order-group.service';

// Others
import { AppComponent } from './app.component';
import { AuthGuard } from './_guards/auth.guard';
import { StoreGuard } from './_guards/store.guard';
import { Globals } from './_globals';

// Layouts
import { ExtLayoutComponent } from './layouts/ext-layout/ext-layout.component';
import { SuperLayoutComponent } from './layouts/super-layout/super-layout.component';
import { OwnerLayoutComponent } from './layouts/owner-layout/owner-layout.component';
import { GroupLayoutComponent } from './layouts/group-layout/group-layout.component';

// 3rd Party
import { CookieService } from 'ngx-cookie-service';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { ToastrModule } from 'ngx-toastr';
import { OrderModule } from 'ngx-order-pipe';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { ScheduleService } from './_services/schedule.service';
import { KioskService } from './_services/kiosk.service';
import { ImagesService } from './_services/images.service';
import { PosService } from './_services/pos.service';
import { ReportingService } from './_services/reporting.service';
import { StripeService } from './_services/stripe.service';

import { AgmCoreModule } from '@agm/core';

// Pipes
import { ObjectFilterPipe } from './_pipes/object-filter.pipe';
import { OrdersService } from './_services/orders.service';
import { CustomersService } from './_services/customer.service';
import { DashboardService } from './_services/dashboard.service';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CommonModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    OrderModule,
    LoadingBarHttpClientModule,
    LoadingBarModule.forRoot(),
    NgbModule.forRoot(),
    ToastrModule.forRoot(),
    FlashMessagesModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAT0bVot4ypYojQ6tlL2HnFPl9v7ZjdDLs',
      libraries: ['places'],
    }),
  ],
  declarations: [AppComponent, SuperLayoutComponent, OwnerLayoutComponent, GroupLayoutComponent, ExtLayoutComponent],
  providers: [
    NotificationService,
    AuthGuard,
    StoreGuard,
    Globals,
    AuthService,
    CookieService,
    CryptoService,
    GroupUserService,
    OwnerUserService,
    StoreService,
    StoreContextService,
    CategoryService,
    FoodToGoService,
    KioskCategoryService,
    AppsService,
    ScheduleService,
    KioskService,
    ImagesService,
    ObjectFilterPipe,
    ProductsService,
    ConsoleUserService,
    PosService,
    ReportingService,
    CustomBuilderService,
    OrderGroupService,
    StripeService,
    OrdersService,
    CustomersService,
    DashboardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorsInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: ErrorsHandler,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts